var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EnvironmentSettings } from 'mi.common.settings.environment.contract';
import { fetch } from '@mitchell/typescript.service.fetch';
import { handleResponse, HttpMethodType, CaseFormatter, normalizeForRedux, formatAsPst, getValueFromSessionStorage, SessionStorageKey } from "../../common";
export class VehicleConfigurationAttributesService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    /**
     * gives the instance of VehicleAttributeService if already created or create new instance
     * @returns VehicleAttributeService
     */
    static getInstance() {
        if (VehicleConfigurationAttributesService.INSTANCE == null) {
            VehicleConfigurationAttributesService.INSTANCE = new VehicleConfigurationAttributesService();
        }
        return VehicleConfigurationAttributesService.INSTANCE;
    }
    /**
     * get list of vehicle attributes details (PIN, NADA or Redbook) for specific vehicle
     * @param vehicleId
     * @returns SAGASERVICEONLY_IVehicleAttributes
     */
    getVehicleConfigurationAttributes(vehicleId, dateOfLoss) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(VehicleConfigurationAttributesService.getVehicleConfigurationAttributeUrl() + vehicleId + '/Attributes');
            let lossDate = dateOfLoss ? formatAsPst(dateOfLoss) : undefined;
            lossDate && url.searchParams.append('dateOfLoss', lossDate);
            const ownerOrgKey = getValueFromSessionStorage(SessionStorageKey.CURRENT_SHOP_KEY);
            ownerOrgKey && url.searchParams.append('OwnerOrgKey', ownerOrgKey);
            return this.fetchWrapper(new Request(url, VehicleConfigurationAttributesService.generateRequestInit(HttpMethodType.GET)))
                .then(response => handleResponse(response))
                .then(response => {
                return CaseFormatter.pascalToCamelCase(response);
            });
        });
    }
    /**
     * normalize attrributes data into redux state
     * @param attributesDataFromServer
     * @returns IVehicleConfigurationAttributesState
     */
    normalizeAttributesData(attributesDataFromServer) {
        var pinAttributesResponse = attributesDataFromServer.pinAttributesResponse;
        var nadaAttributesResponse = attributesDataFromServer.nadaAttributesResponse;
        var redbookAttributesResponse = attributesDataFromServer.redbookAttributesResponse;
        return {
            pinAttributes: pinAttributesResponse &&
                pinAttributesResponse.pinAttributes &&
                normalizeForRedux(pinAttributesResponse.pinAttributes, 'pinVid'),
            nadaAttributes: nadaAttributesResponse &&
                nadaAttributesResponse.nadaAttributes &&
                normalizeForRedux(nadaAttributesResponse.nadaAttributes, 'nadaVid'),
            redbookAttributes: redbookAttributesResponse &&
                redbookAttributesResponse.redbookAttributes &&
                normalizeForRedux(redbookAttributesResponse.redbookAttributes, 'controlNumber')
        };
    }
    static getVehicleConfigurationAttributeUrl() {
        return (EnvironmentSettings.get(window.mitchell.environment).vehicleSelection +
            VehicleConfigurationAttributesService.vehicleIdentificationApi +
            '/Vehicle/');
    }
    static generateRequestInit(httpMethod, body) {
        return {
            method: httpMethod,
            body: body
        };
    }
}
VehicleConfigurationAttributesService.vehicleIdentificationApi = 'v1';
//# sourceMappingURL=VehicleConfigurationAtrributesService.js.map